// /* ALLOW WHITELIST COUNTRIES */
// function redirectHtml() {
//   document.body.innerHTML = `
//   <div class="redirection-box">
//     <div class="redirection-logo">
//       <img
//         src="https://cdn.shopify.com/s/files/1/0755/3017/4762/files/hands_logo.png?v=1686285069" width="200px" height="auto">
//     </div>
//   </div>
//   `;
// }

// function allow_whitelist_countries() {
//   // Whitelist countries
//   const whitelist_singapore = [
//     "SG",
//     "KH",
//     "CN",
//     "ID",
//     "MY",
//     "PH",
//     "KR",
//     "TH",
//     "MO",
//     "VN",
//     "TW",
//     "HK",
//     "Taiwan",
//   ];

//   const whitelist_uae = [
//     "CY",
//     "TR",
//     "BH",
//     "IR",
//     "IQ",
//     "IL",
//     "JO",
//     "KW",
//     "LB",
//     "OM",
//     "PS",
//     "QA",
//     "SA",
//     "AE",
//     "YE",
//     "EG",
//   ];

//   // checkouts page
//   const checkoutsCountry = [
//     "US",
//     "CA",
//     "AT",
//     "BE",
//     "BG",
//     "HR",
//     "CY",
//     "CZ",
//     "DK",
//     "FI",
//     "FR",
//     "DE",
//     "GR",
//     "HU",
//     "IE",
//     "IT",
//     "NL",
//     "NO",
//     "PL",
//     "PT",
//     "RO",
//     "SK",
//     "SI",
//     "ES",
//     "SE",
//     "CH",
//     "TR",
//     "GB",
//     "RS",
//     "AL",
//     "LV",
//     "LI",
//     "LT",
//     "LU",
//     "MT",
//     "TW",
//   ];

//   const middleEastCountry = [
//     "TR",
//     "AE",
//     "SA",
//     "IR",
//     "IL",
//     "JO",
//     "QA",
//     "LB",
//     "IQ",
//     "KW",
//   ];

//   function hideTax() {
//     let tax = document.querySelector(".contact-form-tax");
//     let totalTax = document.querySelector(".contact-form-totaltax");

//     tax.style.display = "none";
//     totalTax.style.display = "none";
//   }
//   function hideMiddleast() {
//     let meCountryHideTax = document.querySelector(".subtotal-title");
//     meCountryHideTax.textContent = "Total (Ex Dubai)";
//   }
//   // Detecting the users country
//   function get_country_code(api_url) {
//     fetch(api_url, { method: "GET" })
//       .then((response) => response.json()) // Getting ip info as json
//       .then((result) => {
//         console.log("country code is ", result.country);
//         const currentUrl = window.location.href;
//         const urlPath = new URL(currentUrl).pathname;
//         // console.log(result);

          
//         if (!whitelist_singapore.includes(result.country)) {
//           // If country code is not in whitelist_singapore
//           if (whitelist_uae.includes(result.country)) {
//             // If country code is in whitelist_uae
//             if (!window.location.href.includes(".ae")) {
//               redirectHtml();
//               window.location.href = `https://handscarpets.ae${urlPath}`;
//             }
//           } else {
//             // If country code is for whitelist for .com domain
//             if (!window.location.href.includes(".com")) {
//               redirectHtml();
//               window.location.href = "https://handscarpets.com/";
//             }
//           }
//         } else if (whitelist_singapore.includes(result.country)) {
//           // If country code is for whitelist for singapore domain
//           console.log("redirecting to asia");
//           if (
//             !window.location.href.includes(".asia") &&
//             result.country !== "IN"
//           ) {
//             redirectHtml();
//             console.log("redirected");
//             window.location.href = `https://handscarpets.asia${urlPath}`;
//           }
//         }
//         // checkouts page js
//         if (window.location.href.includes("/pages/checkouts")) {
//           if (checkoutsCountry.includes(result.country)) {
//             hideTax();
//           }
//           if (middleEastCountry.includes(result.country)) {
//             hideMiddleast();
//           }
//           if (result.country == "IN") {
//             let indSubtotal = document.querySelector(".subtotal-title");
//             indSubtotal.textContent = "Subtotal";
//           }
//         }
//         // hide whatsapp
//         if (result.country == "IN") {
//           let whatsapp = document.querySelector(".whatsapp-container");
//           whatsapp.style.display = "block";
//         }
//       })

//       .catch((error) => console.log("error", error));
//   }

//   // Getting country code from third party api
//   get_country_code("https://get.geojs.io/v1/ip/country.json");
// }

// allow_whitelist_countries();





/* ALLOW WHITELIST COUNTRIES */
// function redirectHtml() {
//   document.body.innerHTML = `
//   <div class="redirection-box">
//     <div class="redirection-logo">
//       <img
//         src="https://cdn.shopify.com/s/files/1/0755/3017/4762/files/hands_logo.png?v=1686285069" width="200px" height="auto">
//     </div>
//   </div>
//   `;
// }

// // Function to detect if the user is a bot
// function isBot() {
//   const userAgent = navigator.userAgent.toLowerCase();
//   const botSignatures = [
//     'bot', 'crawl', 'spider', 'googlebot', 'bingbot', 'yahoobot', 'slurp', 
//     'baiduspider', 'duckduckbot', 'yandexbot', 'sogou', 'exabot', 'facebot', 
//     'ia_archiver', 'mj12bot', 'ahrefsbot', 'semrushbot', 'dotbot', 'petalbot'
//   ];
  
//   return botSignatures.some(signature => userAgent.includes(signature));
// }

// function allow_whitelist_countries() {
//   // Whitelist countries
//   const whitelist_singapore = [
//     "SG",
//     "KH",
//     "CN",
//     "ID",
//     "MY",
//     "PH",
//     "KR",
//     "TH",
//     "MO",
//     "VN",
//     "TW",
//     "HK",
//     "Taiwan",
//   ];

//   const whitelist_uae = [
//     "CY",
//     "TR",
//     "BH",
//     "IR",
//     "IQ",
//     "IL",
//     "JO",
//     "KW",
//     "LB",
//     "OM",
//     "PS",
//     "QA",
//     "SA",
//     "AE",
//     "YE",
//     "EG",
//   ];

//   // Checkouts page
//   const checkoutsCountry = [
//     "US",
//     "CA",
//     "AT",
//     "BE",
//     "BG",
//     "HR",
//     "CY",
//     "CZ",
//     "DK",
//     "FI",
//     "FR",
//     "DE",
//     "GR",
//     "HU",
//     "IE",
//     "IT",
//     "NL",
//     "NO",
//     "PL",
//     "PT",
//     "RO",
//     "SK",
//     "SI",
//     "ES",
//     "SE",
//     "CH",
//     "TR",
//     "GB",
//     "RS",
//     "AL",
//     "LV",
//     "LI",
//     "LT",
//     "LU",
//     "MT",
//     "TW",
//   ];

//   const middleEastCountry = [
//     "TR",
//     "AE",
//     "SA",
//     "IR",
//     "IL",
//     "JO",
//     "QA",
//     "LB",
//     "IQ",
//     "KW",
//   ];

//   function hideTax() {
//     let tax = document.querySelector(".contact-form-tax");
//     let totalTax = document.querySelector(".contact-form-totaltax");
//     if (tax) tax.style.display = "none";
//     if (totalTax) totalTax.style.display = "none";
//   }

//   function hideMiddleast() {
//     let meCountryHideTax = document.querySelector(".subtotal-title");
//     if (meCountryHideTax) meCountryHideTax.textContent = "Total (Ex Dubai)";
//   }

//   // Detecting the user's country
//   function get_country_code(api_url) {
//     fetch(api_url, { method: "GET" })
//       .then((response) => response.json()) // Getting ip info as json
//       .then((result) => {
//         console.log("country code is ", result.country);
//         const currentUrl = window.location.href;
//         const urlPath = new URL(currentUrl).pathname;

//         // Only proceed with redirection for non-bot users
//         if (!isBot()) {
//           if (!whitelist_singapore.includes(result.country)) {
//             // If country code is not in whitelist_singapore
//             if (whitelist_uae.includes(result.country)) {
//               // If country code is in whitelist_uae
//               if (!window.location.href.includes(".ae")) {
//                 redirectHtml();
//                 window.location.href = `https://handscarpets.ae${urlPath}`;
//               }
//             } else {
//               // If country code is not in whitelist_uae or whitelist_singapore, redirect to .com
//               if (!window.location.href.includes(".com")) {
//                 redirectHtml();
//                 window.location.href = `https://handscarpets.com${urlPath}`;
//               }
//             }
//           } else if (whitelist_singapore.includes(result.country)) {
//             // If country code is in whitelist_singapore
//             if (
//               !window.location.href.includes(".asia") &&
//               result.country !== "IN"
//             ) {
//               redirectHtml();
//               console.log("redirected to asia");
//               window.location.href = `https://handscarpets.asia${urlPath}`;
//             }
//           }
//         }

//         // Checkouts page logic (applies to both bots and non-bots)
//         if (window.location.href.includes("/pages/checkouts")) {
//           if (checkoutsCountry.includes(result.country)) {
//             hideTax();
//           }
//           if (middleEastCountry.includes(result.country)) {
//             hideMiddleast();
//           }
//           if (result.country == "IN") {
//             let indSubtotal = document.querySelector(".subtotal-title");
//             if (indSubtotal) indSubtotal.textContent = "Subtotal";
//           }
//         }

//         // WhatsApp visibility (applies to both bots and non-bots)
//         if (result.country == "IN") {
//           let whatsapp = document.querySelector(".whatsapp-container");
//           if (whatsapp) whatsapp.style.display = "block";
//         }
//       })
//       .catch((error) => console.log("error", error));
//   }

//   // Getting country code from third party API
//   get_country_code("https://get.geojs.io/v1/ip/country.json");
// }

// allow_whitelist_countries();



/* ALLOW WHITELIST COUNTRIES */
function redirectHtml() {
  document.body.innerHTML = `
  <div class="redirection-box">
    <div class="redirection-logo">
      <img
        src="https://cdn.shopify.com/s/files/1/0755/3017/4762/files/hands_logo.png?v=1686285069" width="200px" height="auto">
    </div>
  </div>
  `;
}

// Function to detect if the user is a bot
function isBot() {
  const userAgent = navigator.userAgent.toLowerCase();
  const botSignatures = [
    'bot', 'crawl', 'spider', // Generic bot terms
    'googlebot', 'google-inspectiontool', 'googleother', 'adsbot-google', 'mediapartners-google', // Google bots
    'bingbot', 'msnbot', 'bingpreview', // Microsoft/Bing bots
    'yahoobot', 'slurp', // Yahoo
    'baiduspider', // Baidu
    'duckduckbot', // DuckDuckGo
    'yandexbot', 'yandeximages', 'yandexmetrika', // Yandex
    'sogou', // Sogou
    'exabot', // Exalead
    'facebot', 'facebookexternalhit', // Facebook
    'twitterbot', // Twitter
    'linkedinbot', // LinkedIn
    'pinterestbot', // Pinterest
    'slackbot', 'slack-imgproxy', // Slack
    'discordbot', // Discord
    'telegrambot', // Telegram
    'applebot', // Apple
    'amazonbot', 'awscloudbot', // Amazon
    'ia_archiver', // Alexa/Internet Archive
    'mj12bot', 'majestic', // Majestic
    'ahrefsbot', // Ahrefs
    'semrushbot', // SEMrush
    'dotbot', // Moz
    'petalbot', // Huawei
    'seznambot', // Seznam
    'qwantify', // Qwant
    'coccocbot', // Coc Coc
    'yeti', // Naver
    'daum', // Daum
    'sentry', // Sentry monitoring
    'uptimerobot', // UptimeRobot
    'pingdom', // Pingdom
    'siteimprove', // Siteimprove
    'prerender', // Prerender.io
    'archivebot', // Archive.org
    'linkbot', 'backlink', // Link checkers
    'screaming frog', // Screaming Frog SEO
    'deepcrawl', // DeepCrawl
    'webmeup', // WebMeUp
    'rogerbot', // Moz RogerBot
    'megaindex', // MegaIndex
    'blexbot', // BLEXBot
    'barkrowler', // Barkrowler
    'netcraft', // Netcraft
    'surdotlybot', // Surdotly
    'bytespider', // ByteDance
    'tineye', // TinEye
    'commoncrawl', // Common Crawl
    'heritrix', // Heritrix
    'sistrix', // SISTRIX
    'wotbox', // Wotbox
    'genieo', // Genieo
    'trendictionbot', // Trendiction
    'proximic', // Proximic
    'domaincrawler', // DomainCrawler
    'xenu', // Xenu Link Sleuth
    'scrapy', // Scrapy framework
    'python-requests', 'python-urllib', // Python-based crawlers
    'curl', 'wget', // Command-line tools
    'httpclient', 'okhttp', // HTTP clients
    'headlesschrome', // Headless Chrome
    'phantomjs', // PhantomJS
    'playwright', 'puppeteer' // Automation frameworks
  ];
  // console.log("useragent", userAgent, "data", botSignatures.some(signature => userAgent.includes(signature)))
  return botSignatures.some(signature => userAgent.includes(signature));
}

function allow_whitelist_countries() {
  // Whitelist countries
  const whitelist_singapore = [
    "SG",
    "KH",
    "CN",
    "ID",
    "MY",
    "PH",
    "KR",
    "TH",
    "MO",
    "VN",
    "TW",
    "HK",
    "Taiwan",
  ];

  const whitelist_uae = [
    "CY",
    "TR",
    "BH",
    "IR",
    "IQ",
    "IL",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "AE",
    "YE",
    "EG",
  ];

  // Checkouts page
  const checkoutsCountry = [
    "US",
    "CA",
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "GB",
    "RS",
    "AL",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "TW",
  ];

  const middleEastCountry = [
    "TR",
    "AE",
    "SA",
    "IR",
    "IL",
    "JO",
    "QA",
    "LB",
    "IQ",
    "KW",
  ];

  function hideTax() {
    let tax = document.querySelector(".contact-form-tax");
    let totalTax = document.querySelector(".contact-form-totaltax");
    if (tax) tax.style.display = "none";
    if (totalTax) totalTax.style.display = "none";
  }

  function hideMiddleast() {
    let meCountryHideTax = document.querySelector(".subtotal-title");
    if (meCountryHideTax) meCountryHideTax.textContent = "Total (Ex Dubai)";
  }

  // Detecting the user's country
  function get_country_code(api_url) {
    fetch(api_url, { method: "GET" })
      .then((response) => response.json()) // Getting ip info as json
      .then((result) => {
        console.log("country code is ", result.country);
        const currentUrl = window.location.href;
        const urlPath = new URL(currentUrl).pathname;

        // Check if user is a bot
        if (isBot()) {
          console.log("bot"); // Log "bot" to console
          // document.title = "bot"; // Change page title to "bot"
        } else {
          // Redirection logic for non-bot users
          if (!whitelist_singapore.includes(result.country)) {
            // If country code is not in whitelist_singapore
            if (whitelist_uae.includes(result.country)) {
              // If country code is in whitelist_uae
              if (!window.location.href.includes(".ae")) {
                redirectHtml();
                window.location.href = `https://handscarpets.ae${urlPath}`;
              }
            } else {
              // If country code is not in whitelist_uae or whitelist_singapore, redirect to .com
              if (!window.location.href.includes(".com")) {
                redirectHtml();
                window.location.href = `https://handscarpets.com${urlPath}`;
              }
            }
          } else if (whitelist_singapore.includes(result.country)) {
            // If country code is in whitelist_singapore
            if (
              !window.location.href.includes(".asia") &&
              result.country !== "IN"
            ) {
              redirectHtml();
              console.log("redirected to asia");
              window.location.href = `https://handscarpets.asia${urlPath}`;
            }
          }
        }

        // Checkouts page logic (applies to both bots and non-bots)
        if (window.location.href.includes("/pages/checkouts")) {
          if (checkoutsCountry.includes(result.country)) {
            hideTax();
          }
          if (middleEastCountry.includes(result.country)) {
            hideMiddleast();
          }
          if (result.country == "IN") {
            let indSubtotal = document.querySelector(".subtotal-title");
            if (indSubtotal) indSubtotal.textContent = "Subtotal";
          }
        }

        // WhatsApp visibility (applies to both bots and non-bots)
        if (result.country == "IN") {
          let whatsapp = document.querySelector(".whatsapp-container");
          if (whatsapp) whatsapp.style.display = "block";
        }
      })
      .catch((error) => console.log("error", error));
  }

  // Getting country code from third party API
  get_country_code("https://get.geojs.io/v1/ip/country.json");
}

allow_whitelist_countries();